export default __webpack_public_path__ + "f9593826881b27c919ec5df0027f6124.glb";